export const configFirebase = {
  apiKey: "AIzaSyCmyYTOZlJeEV4riZSvw7qRciWMQ-buKFQ",
    authDomain: "imcl-selfcare.firebaseapp.com",
    databaseURL: "https://imcl-selfcare.firebaseio.com",
    projectId: "imcl-selfcare",
    storageBucket: "imcl-selfcare.appspot.com",
    messagingSenderId: "361777923362",
    appId: "1:361777923362:web:c60692e610f5db931c117b",
    measurementId: "G-XX8NXVHT2J"
}


// WEBPACK FOOTER //
// ./src/store/config/firebaseConfig.js